import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getAccountEmail,
  getDeleteAccountLink,
} from 'app/store/Auth/selectors';
import { config } from 'config';

interface UseAccountSettingsRowsProps {
  setEmailChangeOpen: (state: boolean) => void;
  setPasswordChangeOpen: (state: boolean) => void;
  setDeleteAccountOpen: (state: boolean) => void;
}

export const useAccountSettingsRows = ({
  setEmailChangeOpen,
  setPasswordChangeOpen,
  setDeleteAccountOpen,
}: UseAccountSettingsRowsProps) => {
  const dispatch = useAppDispatch();
  const currentEmail = useAppSelector(getAccountEmail);
  const deleteAccountLink = useAppSelector(getDeleteAccountLink);

  return useMemo(
    () => {
      return [
        {
          primaryText: 'Email',
          secondaryText: currentEmail,
          secondTextTestId: 'current-email-text',
          button: { label: 'Update', action: () => setEmailChangeOpen(true) },
        },
        {
          primaryText: 'Password',
          button: {
            label: 'Change',
            action: () => setPasswordChangeOpen(true),
          },
        },
        ...(deleteAccountLink
          ? [
              {
                primaryText: 'Delete Account',
                secondaryText: 'Permanently delete your account',
                secondTextTestId: 'delete-account-text',
                button: {
                  label: 'Delete',
                  action: () => setDeleteAccountOpen(true),
                },
                sx: { pb: config.isElectronBuild ? 4 : 7 },
              },
            ]
          : []),
      ];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentEmail, deleteAccountLink, dispatch]
  );
};
